import { Button, Link, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import { useHippoText } from '../../../hooks/useHippoText';
import CoverageTable from '../../../shared_components/CoverageTextsModal/CoverageTable';

const CoveragePackageModalLink = ({
    modalName,
    title,
    description,
    included = [],
    excluded = []
}: {
    modalName: string;
    title: string;
    description: string;
    included?: string[];
    excluded?: string[];
}): React.JSX.Element => {
    const [showModal, setShowModal] = useState(false);
    const getHippoText = useHippoText();
    const tableHeaderIncludedText = getHippoText('DSS-COVERAGE-MODAL-COVERS-HEADER');
    const tableHeaderExcludedText = getHippoText('DSS-COVERAGE-MODAL-DO-NOT-COVER-HEADER');

    return (
        <>
            <Link
                className="u-color-primary-2-base"
                onClick={() => {
                    setShowModal(true);
                }}
            >
                {modalName}
            </Link>
            {showModal && (
                <ModalOverlay
                    isOpen={showModal}
                    onDismiss={() => {
                        setShowModal(false);
                    }}
                >
                    <ModalDialog
                        closeIconHandler={() => {
                            setShowModal(false);
                        }}
                    >
                        <div className="u-spacing-inset-l">
                            <div className="u-spacing-inset-l--stretch-max">
                                <h4 className="u-spacing-stack-sm">
                                    {DOMPurify.sanitize(getHippoText(title))}
                                </h4>
                                <p
                                    className="u-spacing-stack-sm"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(getHippoText(description))
                                    }}
                                />
                                {(included.length > 0 || excluded.length > 0) && (
                                    <CoverageTable
                                        included={included}
                                        excluded={excluded}
                                        includedTitle={tableHeaderIncludedText}
                                        excludedTitle={tableHeaderExcludedText}
                                    />
                                )}
                            </div>
                            <Button
                                onClick={() => {
                                    setShowModal(false);
                                }}
                            >
                                {getHippoText('DSS-COMMON-CLOSE')}
                            </Button>
                        </div>
                    </ModalDialog>
                </ModalOverlay>
            )}
        </>
    );
};

export default CoveragePackageModalLink;
